// How payment works at the Colonie shop, stated in the welcome email.
//
// Albany takes no cash, and the balance is settled electronically before the
// car is handed back. That is a different arrangement from Kingston, and the
// customer needs it in writing at BOOKING time — not when they arrive with
// notes in their hand.
//
// 🚨 This REPLACES the deposit block for these customers rather than joining
// it. Asking for a deposit and then telling the same person their whole
// balance arrives electronically before pick-up is two payment stories in one
// email; Ryder's call 2026-09-07 was to drop the deposit here entirely.
//
// ⚠️ Deliberately carries NO payment link and NO figure. The link would be
// dead: 3c-balance.html and api/balance-charge.js both resolve the amount from
// bookings.invoice_total (or a manually-typed balance_amount), and at booking
// time neither exists — the page refuses to render a Pay button and the charge
// endpoint returns "No balance due". The real link goes out with the balance
// request once the invoice is cut, which is what "before pick-up" means.

import { KINGSTON, ALBANY } from './sites';

// Who gets this paragraph.
//
// Colonie, and NOT a dealership job: an OTTO customer never pays 3C at all —
// the dealership is invoiced at the partner rate and settles with their own
// customer. Telling them how to pay us would be inviting a payment we must
// not take. Same test the deposit block already uses to exclude them.
export function albanyPaymentApplies(b) {
  if (!b) return false;
  if (String(b.dealer || '').trim()) return false;
  return String(b.site || KINGSTON) === ALBANY;
}

export const ALBANY_PAY_LEAD = 'A note on payment at our Colonie shop:';
export const ALBANY_PAY_TAIL =
  'Paying by check? Ask us for the total at any time and we will send it over — '
  + 'please have the check written out before you arrive.';

// Returned as an array so the builder splices it in without re-deciding the
// blank lines, exactly like depositLines().
export function albanyPaymentLines() {
  return [
    '',
    ALBANY_PAY_LEAD,
    '',
    'We do not accept cash at this location.',
    '',
    'Your balance — the service plus NYS sales tax and the 4% card fee — will be '
      + 'sent to you electronically before pick-up, so it can be settled before you arrive.',
    '',
    ALBANY_PAY_TAIL,
  ];
}

// Same both-ends anchoring as withoutDepositBlock: a body the operator has
// reworded is left alone rather than half-cut.
export function hasAlbanyPaymentBlock(body) {
  const t = String(body || '');
  return t.includes(ALBANY_PAY_LEAD) && t.includes(ALBANY_PAY_TAIL);
}
